// @todo: just reserved mock for future usage
export function getTranslation(content) {
    return content.de;
}
